import { NgModule } from '@angular/core';
import { ArticleDetailsComponent } from './article-details.component';
import { ArticleDetailsRoutingModule } from './article-details-routing.module';
import { ArticleService } from './article.service';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [ArticleDetailsRoutingModule, SharedModule],
  declarations: [ArticleDetailsComponent],
  exports: [ArticleDetailsComponent],
  providers: [ArticleService]
})
export class ArticleDetailsModule { }
